import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

const routes: Routes = [
  Shell.childRoutes([
    { path: getRoutePath(PlRoute.home, false), redirectTo: '', pathMatch: 'full' },
    { path: '', component: HomeComponent },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class HomeRoutingModule {}
